import type { Caption } from "../../audio/game-audio.ts";
import { h } from "../kit/dom.ts";

/** Preferência das legendas (a tela de opções é da F30): `eldrun:legendas` = "1" liga. */
export const CAPTIONS_PREF = "legendas";

/**
 * Legendas de sons importantes com a direção (doc 05, acessibilidade): "Redemoinho à esquerda".
 * Acima do cinto, sem pegar cliques; só aparecem com a opção ligada.
 */
export class CaptionsHud {
  readonly element: HTMLElement;
  /** Opções (F30): liga e desliga na hora. */
  enabled: boolean;
  private key = "";

  constructor(parent: HTMLElement, enabled: boolean) {
    this.enabled = enabled;
    this.element = h("ul", { id: "legendas", "aria-live": "polite", "aria-label": "Legendas" });
    this.element.hidden = true;
    parent.appendChild(this.element);
  }

  update(captions: readonly Caption[]): void {
    const shown = this.enabled ? captions : [];
    const key = shown.map((c) => c.text).join("|");
    if (key === this.key) return;
    this.key = key;
    this.element.hidden = shown.length === 0;
    this.element.replaceChildren(...shown.map((c) => h("li", {}, c.text)));
  }

  remove(): void {
    this.element.remove();
  }
}
